import TooltipWrapper from './TooltipWrapper';

export function CompulsoryFilter(props) {
	const className =
		props.className ??
		'toolkit-fitler compulsory-filter input-wrap d-flex justify-content-between';

	return (
		<div className={className}>
			<span htmlFor="is_compulsory" className="d-flex w-100 align-items-center">
				<span className="me-2">Compulsory only</span>
				<TooltipWrapper
					tooltipId="compulsory-tooltip"
					tooltipContent="These are documents with information you must provide to employees as part of your pension duties."
				/>

				<label className="switch">
					<input
						type="checkbox"
						aria-labelledby={props.id + '-label'}
						{...props}
					/>
					<span className="slider"></span>
				</label>
			</span>
		</div>
	);
}

export default CompulsoryFilter;
